import React, {useState, useEffect} from 'react';
import { observer } from 'mobx-react'
import Domen from "../../../stores/Domen";
import './index.css';
import GlobalState from "../../../stores/GlobalState";
import lang from "../../../lang"
const Priview = observer(({ lower, upper, activemodel }) => {
    const [line, setLine] = useState([
        {z:1},
        {z:1},
        {z:1},
        {z:1},
        {z:1},
        {z:1},
        {z:1},
        {z:1},
        {z:1},
        {z:1},
        {z:1},
        {z:1},
        {z:1},
        {z:1},
        {z:1},
        {z:1},
        {z:1},
        {z:1},
        {z:1},
        {z:1}
    ])
    const [langmenu, setLangmenu] = useState(localStorage.getItem("lang_site")||"en")
    const [langv, setLangv]= useState(langmenu=="de"?lang.de:lang.en)
    const [top, setTop]= useState([])

    async function getModel()
    {
        var token = localStorage.getItem("token");
        localStorage.setItem("countactivetime", Date.now());
        const response = await fetch(Domen.url + `model/`+activemodel+'/predictPreview?bypass_cache=false&lowerThreshold='+lower+'&upperThreshold='+upper, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        if(response.status=="200")
        {
            const data = await response.json();
            console.log("testu"+data);
            setTop(data);
            // updateTresh();
        }
    } 

    async function updateTresh()
    {
        var token = localStorage.getItem("token");
        localStorage.setItem("countactivetime", Date.now());
         var model = {
            upperThreshold: upper,
            lowerThreshold: lower
        };
        const response = await fetch(Domen.url + `model/`+activemodel+'/threshold', {
            method: 'POST',
            headers: {
                'Authorization': token,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(model),
        })
        if(response.status=="200")
        {
            const data = await response.json();
                       
        }
    } 
    useEffect(() => {
        getModel()
    }, [lower, upper])
    return (
        <div className='priview'>
            <div className='priview_tittle'>
            {langv?.module_models?.preview?.text1}
            </div>
            <div className='priview_body'>
                <div className='priview_body_scroll'>
                    <div className='priview_body_head'>
                        {
                            lower?
                            top?.map((n, id)=>
                                id==0?
                                Object.entries(n).map(([key, value])=>
                                    <div className='priview_body_head_col_1 head_line_padding'>
                                        {key.length>15?<></>:key}
                                        {   
                                            key.length>15?
                                            <>
                                            {key.substr(0, 14)}
                                            <span className='open_tooltipa_head_prew'> ...
                                                <div className='tooltipa_head_prew'>{key}</div>
                                            </span>
                                            
                                            </>
                                            :
                                            <></>
                                        }
                                    </div>
                                )
                                :
                                <></>
                            )
                            :
                            GlobalState.activemodel?.lastTrain?.metadata?.predictPreview?.map((n, id)=>
                                id==0?
                                Object.entries(n).map(([key, value])=>
                                    <div className='priview_body_head_col_1 head_line_padding'>
                                        {key.length>15?<></>:key}
                                        {   
                                            key.length>15?
                                            <>
                                            {key.substr(0, 14)}
                                            <span className='open_tooltipa_head_prew'> ...
                                                <div className='tooltipa_head_prew'>{key}</div>
                                            </span>
                                            
                                            </>
                                            :
                                            <></>
                                        }
                                    </div>
                                )
                                :
                                <></>
                            )
                        }
                        
                    </div>
                    <div className='priview_body_body'>
                        {
                            lower?
                            top?.map((n, id)=>
                                <div className='priview_body_body_line'>
                                    {
                                        Object.entries(n).map(([key, value], columnIndex)=>
                                            <div className='priview_body_head_col_1 head_line_padding'>
                                                
                                                <div className='priview_body_head_col_1'>
                                                    <input
                                                        id="source"
                                                        type="text"
                                                        disabled="true"
                                                        placeholder="Churn Prediction "
                                                        className=""
                                                        value={
                                                            columnIndex === 0
                                                                ? value
                                                                : (!isNaN(value) && value !== ''
                                                                    ? Number(value).toFixed(2)
                                                                    : value)
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                            )
                            :
                            GlobalState.activemodel?.lastTrain?.metadata?.predictPreview?.map((n, id)=>
                                <div className='priview_body_body_line'>
                                    {
                                        Object.entries(n).map(([key, value])=>
                                            <div className='priview_body_head_col_1 head_line_padding'>
                                                
                                                <div className='priview_body_head_col_1'>
                                                    <input
                                                        id="source"
                                                        type="text"
                                                        disabled="true"
                                                        placeholder="Churn Prediction "
                                                        className=""
                                                        value={value}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                            )
                        }
                        <div className='count_prew'>
                            {/* {GlobalState.activemodel?.lastTrain?.metadata?.metrics?.support} */}
                        {langv?.module_models?.preview?.text2} - 20 {langv?.module_models?.preview?.text3}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
})
export default Priview;